import React from "react";
import { AppContent, AppHeader, Footer } from "../../components";
import AppSidebar from "src/components/AppSidebar";

const Home = () => {
  return (
    <>
      <div
        className="wrapper d-flex flex-column min-vh-100"
        style={{ backgroundColor: "#2c2c2c" }} // Dark background color
      >
        <AppHeader />
        <div className="body flex-grow-1 ">
          <AppContent />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
